import type { Arrayable } from 'types/Arrayable';

export const arrayable = <T>(arrayableValue: Arrayable<T>) => {
  if (Array.isArray(arrayableValue)) {
    return arrayableValue;
  }

  return [arrayableValue];
};
